// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3KsO0","error":"Textarea_error__1H4k3","readonly":"Textarea_readonly__19kkl","disabled":"Textarea_disabled__3LJyw"};